export default "__VITE_ASSET__DW6iIGnz__"